module.exports = __webpack_public_path__ + "img/prices_slider.bf6460cb.jpg";